var $ = require('jquery');

$(function () {

    $('.column-list-links__list').slick({
        arrows: true,
        customPaging: function (slick, index) {
            return '<span class="number">' + (index + 1) + '</span>';
        },
        dots: true,
        mobileFirst: true,
        slidesToShow: 2,
        slidesToScroll: 2,
        responsive: [{
            breakpoint: 767,
            settings: 'unslick'
        }],
        rtl: window.GenericUtilities.isRTL()
    });
    // to get slick slider to initialize on screen resize
    // https://github.com/kenwheeler/slick/issues/1730
    $(window).on('resize orientationchange', function () {
        $('.column-list-links__list').slick('resize');
    });
});
